import { render, staticRenderFns } from "./ConfigurationList.vue?vue&type=template&id=245cc1bc&"
import script from "./ConfigurationList.vue?vue&type=script&lang=js&"
export * from "./ConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports